// Returns an array that includes the permission and its broader parent permissions.
// 'asset.status_check.read' => ['asset.*', 'asset.status_check.*', 'asset.status_check.read']
export function getPermissionsWithParentScopes(permission: string): string[] {
    const permissionParentScopes = permission.split('.');

    return permissionParentScopes.map((scope, index, array) => {
        // Return the original permission in case of the last item
        if (array.length === index + 1) {
            return permission;
        }

        // Match everything starting from scope to end of string
        const pattern = `(${scope}).*$`;
        const regex = new RegExp(pattern);
        return permission.replace(regex, '$1.*');
    });
}
